const Map = () =>
  import(
    /* webpackChunkName: "system-setting-map" */ '@/pages/system/setting/map.vue'
  )

export default {
  path: 'map',
  meta: {
    label: 'map',
    auth: 'map'
  },
  component: {
    name: 'Map',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemSettingMap',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Map
    }
  ]
}
